<template>
  <div class="container page">
    <van-nav-bar title="Deposit money" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main-content">
      <van-button class="channel-btn" type="primary" @click="onSubmit()">Bank</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Form } from "vant";
import { Field } from "vant";
import { RadioGroup, Radio } from "vant";
Vue.use(Form).use(Field).use(RadioGroup).use(Radio);
export default {
  data() {
    return {
    };
  },
  mounted() {
    this.balance = this.$route.params.balance;
  },
  methods: {
    back() {
      return window.history.back();
    },
    //拉起支付
    onSubmit() {
      this.$toast("Please contact customer service to recharge!");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.nav-bar {
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #333;
  font-size: 0.42667rem;
  font-weight: 500;
}

.main-content {
  padding: 0.8rem;
}

.channel-btn {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.03333rem;
  font-size: 0.42667rem;
  font-weight: 500;
  border: none;
  background: #5B60DF;
  color: #fff;
}

::v-deep .van-button__text {
  color: #fff;
}
</style>